import React, {useEffect, useRef, useState} from "react";
import {Button, Col, Form, Modal, OverlayTrigger, Popover, Row, Tab, Table, Tabs} from "react-bootstrap";
import ApiService from "../services/ApiService";
import {useNavigate, useParams} from "react-router-dom";
import {newsletters, roles, statuses} from "../utils/reusableText";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowLeft, faCopy, faEdit, faPlus} from '@fortawesome/pro-light-svg-icons';
import DataTable from 'react-data-table-component';
import {countries} from 'countries-list';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import AlertShow from "../components/AlertShow";
import {getUser, getToken} from "../services/AuthService";
import EventObserver from "../utils/EventObserver";

const paginationOptions = {
    rowsPerPageText: 'Righe per pagina:',
    rangeSeparatorText: 'di',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Tutte',
};

const columns = [
    {
        name: 'Data/Ora operazione',
        selector: row => row.date,
        sortable: true,
    },
    {
        name: 'Tipologia Abbonamento',
        selector: row => row.subscriptionCode,
    },
    {
        name: 'Operazione',
        selector: row => row.operation,
    },
    {
        name: 'Staff user',
        selector: row => row.modifyBy,
    }
];

const EditUser = () => {
    const currentUser = getUser();
    const param = useParams();
    const navigate = useNavigate();

    const [userData, setUserData] = useState({
        id: undefined,
        uuid: '',
        status: '',
        source: '',
        email: '',
        firstName: '',
        lastName: '',
        username: '',
        dob: '',
        clientNumber: null,
        salutation: '',
        roles: [''],
        groups: [''],
        password: '',
        addressProfile: [
            {
                id: undefined,
                city: '',
                street: '',
                country: 'CH',
                zip: '',
                streetNumber: '',
                phonePrefix: '',
                phone: '',
                mobilePhonePrefix: '',
                mobilePhone: '',
            },
        ],
        type: '',
        gender: '',
        subscriptions: [
            {
                userSubscriptionId: undefined,
                subscriptionId: undefined,
                code: '',
                label: '',
                description: '',
                activationDate: '',
                expirationDate: '',
                status: '',
            },
        ],
        lastLoginFormatted: null,
        notes: '',
        qrcode: '',
        newsletter: false,
        newsletter_1: false,
        newsletter_2: false
    });

    const [showModalSub, setShowModalSub] = useState(false);
    const [showModalConfirm, setShowModalConfirm] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [allSubType, setAllSubType] = useState([]);
    const [subscriptionSelected, setSubscriptionSelected] = useState([]);
    const [subscriptionId, setSubscriptionId] = useState(undefined);
    const [activationDate, setActivationDate] = useState(undefined);
    const [expirationDate, setExpirationDate] = useState(undefined);
    const [subsHistory, setSubsHistory] = useState([]);
    //const [subAlreadyPresent, setSubAlreadyPresent] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState(undefined);
    const [passwordMatchError, setPasswordMatchError] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [showAlertSuccess, setShowAlertSuccess] = useState(false);
    const [textAlert, setTextAlert] = useState('Qualcosa è andato storto. Per favore, riprova!');
    const clientNumberInputRef = useRef(null);
    const [feedbackMessage, setFeedbackMessage] = useState('');
    const [originalClientNumber, setOriginalClientNumber] = useState(null);
    const [clientNumberModified, setClientNumberModified] = useState(false);

    const handleClose = () => setShowModalSub(false);
    const [disabled, setDisabled] = useState(false);
    const [modalLinkChangePassword, setModalLinkChangePassword] = useState(false);
    const [linkChangePassword, setLinkChangePassword] = useState(false);
    const linkChangePasswordRef = useRef(null);

    useEffect(() => {
        // Check if Keycloak is already ready (token exists in localStorage)
        const token = getToken();
        if (token && param.id) {
            fetchUserById();
        } else if (param.id) {
            // If not ready yet, listen for the event
            EventObserver.on("keycloakReady", (data) => {
                if (data && param.id) {
                    fetchUserById();
                }
            });
        }
        // eslint-disable-next-line
    }, []);

    function checkPasswordValidation(value) {
        setConfirmPassword(value);

        if (userData.password !== value) {
            setPasswordMatchError(true);
        } else {
            setPasswordMatchError(false)
        }
    }

    function fetchSubsHistory(id) {
        ApiService.getSubsHistory(id).then(response => {
            setSubsHistory(response);
        })
    }

    function fetchUserById() {
        ApiService.getUserById(param.id).then(response => {
            setUserData(response);
            setOriginalClientNumber(response.clientNumber);
            if (response.status === statuses.disabled) {
                setDisabled(true)
            }
/*            if (response.subscriptions.length > 0) {
                setSubAlreadyPresent(true);
            }*/
        }).catch(error => {
            setTextAlert(error?.message || 'Qualcosa è andato storto. Per favore, riprova!');
            setShowAlert(true);
        });
    }

    function updateSubscription() {
        const body = {
            subscriptionId: subscriptionId,
            activationDate: activationDate,
            expirationDate: expirationDate
        }

        ApiService.editSubscription(userData.id, subscriptionSelected.userSubscriptionId, body).then(response => {
            setUserData(response);
            setShowModalSub(false);
            setShowAlertSuccess(true);
        }).catch(error => {
            setTextAlert(error?.message || 'Qualcosa è andato storto. Per favore, riprova!');
            setShowAlert(true);
        });
    }

    function createSubscription() {
        // Controllo aggiuntivo per prevenire duplicati
        const existingSubscriptionIds = userData?.subscriptions?.map(sub => sub.subscriptionId) || [];
        if (existingSubscriptionIds.includes(parseInt(subscriptionId))) {
            setTextAlert('Questa tipologia di abbonamento è già presente per questo utente.');
            setShowAlert(true);
            return;
        }

        const body = {
            subscriptionId: subscriptionId,
            activationDate: activationDate,
            expirationDate: expirationDate
        }
        ApiService.addSubscription(userData.id, body).then(response => {
            setUserData(response);
            setShowModalSub(false);
            setShowAlertSuccess(true);
        }).catch(error => {
            setTextAlert(error?.message || 'Qualcosa è andato storto. Per favore, riprova!');
            setShowAlert(true);
        });
    }

    function openModalToCreate() {
        setSubscriptionSelected([]);
        ApiService.getAllSubscription().then(response => {
            // Filtra le tipologie già presenti negli abbonamenti dell'utente
            const existingSubscriptionIds = userData?.subscriptions?.map(sub => sub.subscriptionId) || [];
            const availableSubTypes = response.filter(subType => !existingSubscriptionIds.includes(subType.id));
            
            if (availableSubTypes.length === 0) {
                setTextAlert('Tutte le tipologie di abbonamento sono già presenti per questo utente.');
                setShowAlert(true);
                return;
            }
            
            setAllSubType(availableSubTypes);
            setSubscriptionId(availableSubTypes[0]?.id);
            setIsEdit(false);
            setShowModalSub(true);
        })
    }

    function openModalToEdit(userSubId) {
        const [subSelected] = userData?.subscriptions?.filter(sub => sub.userSubscriptionId === userSubId)
        setSubscriptionSelected(subSelected);
        ApiService.getAllSubscription().then(response => {
            setAllSubType(response);
            setSubscriptionId(subSelected.subscriptionId);
            setExpirationDate(subSelected.expirationDateNoFormat);
            setActivationDate(subSelected.activationDateNoFormat);
        })
        setIsEdit(true);
        setShowModalSub(true);
    }

    function updateUser() {
        const body = {
            "salutation": userData?.salutation ? userData.salutation : 'SIGNOR',
            "firstName": userData?.firstName,
            "lastName": userData?.lastName,
            "dob": userData?.dob,
            "clientNumber": userData?.clientNumber,
            "street": userData?.addressProfile?.[0]?.street,
            "streetNumber": userData?.addressProfile?.[0]?.streetNumber,
            "zip": userData?.addressProfile?.[0]?.zip,
            "city": userData?.addressProfile?.[0]?.city,
            "country": userData?.addressProfile?.[0]?.country,
            "mobilePhone": userData?.addressProfile?.[0]?.mobilePhone,
            "phone": userData?.addressProfile?.[0]?.phone,
            "password": userData?.password,
            "notes": userData?.notes,
            "newsletter": userData?.newsletter,
            "newsletter_1": userData?.newsletter_1,
            "newsletter_2": userData?.newsletter_2,
            "roles": userData.roles,
            "email": currentUser?.role === 'superAdmin' ? userData?.email : null
        }

        ApiService.editUser(userData.id, body).then(response => {
            setUserData(response);
            setOriginalClientNumber(response.clientNumber);
            setClientNumberModified(false);
            setShowAlertSuccess(true);
        }).catch(error => {
            setTextAlert(error?.message || 'Qualcosa è andato storto. Per favore, riprova!');
            setShowAlert(true);
        });
    }

    function createUser() {
        const currUrl = window.location;
        const body = {
            "salutation": userData?.salutation ? userData.salutation : 'Signor',
            "firstName": userData.firstName,
            "lastName": userData.lastName,
            "dob": userData.dob,
            "street": userData.addressProfile?.[0]?.street,
            "streetNumber": userData.addressProfile?.[0]?.streetNumber,
            "zip": userData.addressProfile?.[0]?.zip,
            "city": userData.addressProfile?.[0]?.city,
            "country": userData.addressProfile?.[0]?.country,
            "mobilePhone": userData.addressProfile?.[0]?.mobilePhone,
            "phone": userData.addressProfile?.[0]?.phone,
            "password": userData.password,
            "notes": userData.notes,
            "newsletter": userData?.newsletter,
            "newsletter_1": userData?.newsletter_1,
            "newsletter_2": userData?.newsletter_2,
            "email": userData.email
        }

        ApiService.createUser(body, currUrl).then(response => {
            if (response.ok) {
                return response.json();
            } else {
                throw response;
            }
        }).then(response => {
            setUserData(response);
            navigate('/fe/edit-user/' + response.id)
        }).catch((error) => {
            setTextAlert(error?.message || 'Qualcosa è andato storto. Per favore, riprova!');
            setShowAlert(true);
        });
    }

    function checkForm() {
        if (param.id) {
            return !(
                userData.salutation !== '' &&
                userData.firstName !== '' &&
                userData.lastName !== '')
        } else {
            return !(
                userData.salutation !== '' &&
                userData.firstName !== '' &&
                userData.lastName !== '' &&
                userData.email !== '')
        }
    }

    const validateEmail = (email) => {
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        return emailRegex.test(email);
    };

    const handleChange = (e) => {
        const email = e.target.value;
        setUserData({
            ...userData,
            email: email
        });
        if (validateEmail(email)) {
            setEmailError('');
        } else {
            setEmailError("Email non valida");
        }
    };

    const handleCopyToClipboard = () => {
        if (clientNumberInputRef.current) {
            clientNumberInputRef.current.select();
            document.execCommand('copy');
            setFeedbackMessage('Numero cliente copiato negli appunti: ' + clientNumberInputRef.current.value);
        }
    };

    const handleCopyToClipboardLink = () => {
        if (linkChangePasswordRef.current) {
            linkChangePasswordRef.current.select();
            document.execCommand('copy');
            setFeedbackMessage('Link copiato negli appunti: ' + linkChangePasswordRef.current.value);
        }
    };

    const popover = (
        <Popover id="popover-basic">
            <Popover.Body>
                {feedbackMessage}
            </Popover.Body>
        </Popover>
    );

    function enableUser() {
        ApiService.enableUser(param?.id).then((res) => {
            if (res.ok) {
                setShowAlertSuccess(true);
                navigate('/fe')
            } else {
                setShowAlert(true);
            }
        });
    }

    function safeDeleteUser() {
        ApiService.safeDeleteUser(param?.id).then(response => {
            if (response.ok) {
                setUserData(response);
                setShowAlertSuccess(true);
                navigate('/fe')
            } else {
                setShowAlert(true);
            }
        });
    }

    function generateLinkChangePassword() {
        ApiService.sendChangePasswordToken(userData?.email).then(res => {
            setLinkChangePassword(res.link);
            setModalLinkChangePassword(true)
        }).catch(err => {
            setTextAlert(err?.message || 'Qualcosa è andato storto. Per favore, riprova!');
            setShowAlert(true)
        });
    }

    function cancelClientNumberChanges() {
        setUserData({
            ...userData,
            clientNumber: originalClientNumber
        });
        setClientNumberModified(false);
    }

    return (
        <>
            <Row className={'content-main'}>
                <Col>
                    <AlertShow show={showAlert} setShow={setShowAlert} variant={"danger"} title={"Errore!"}
                               content={textAlert}></AlertShow>

                    <AlertShow show={showAlertSuccess} setShow={setShowAlertSuccess} variant={"success"} title={""}
                               content={'Modifiche effettuate con successo!'}></AlertShow>

                    <Tabs
                        defaultActiveKey="main"
                        id="tabs"
                        className="mb-3"
                        onSelect={param.id ? () => fetchSubsHistory(param.id) : undefined}
                    >
                        <Tab eventKey="main" title="Main">
                            <Form>
                                <>
                                    <Row className={'my-3 justify-content-between'}>
                                        {param.id ?
                                            <Col>
                                                <div className={'d-flex gap-2 flex-column'}>
                                                    <div className={'d-flex gap-3 align-items-center'}>
                                                        <p className={'mb-0'}>Status
                                                            account: {userData ? userData.status : ''} </p>
                                                        {userData.status === statuses.registered ?
                                                            <Button variant={'primary'} className={'px-3'}
                                                                    size={'sm'}
                                                                    onClick={() => enableUser()}>Abilita</Button>
                                                            :
                                                            <></>}
                                                    </div>
                                                    <p className={'mb-0'}>Ultimo
                                                        accesso: {userData && userData.lastLoginFormatted !== null ? userData.lastLoginFormatted?.split(' ')[0] : '---'}</p>
                                                    <p className={'mb-0'}>Ruolo: {userData && 
                                                        userData.roles && 
                                                        userData.roles.length > 0 ? (
                                                            userData.roles[0] === roles.user || userData.roles[0] === roles.userWithSub  || userData.roles[0] === roles.masi ? 'utente' : 'admin') : ''}</p>
                                                </div>

                                            </Col>
                                            :
                                            <></>}
                                        <Col>
                                            <div className={'d-flex h-100 align-items-end justify-content-end'}>
                                                <Form.Group className={'mb-2 text-end'} controlId="newsletter">
                                                    <Form.Check
                                                        id={newsletters.newsletter}
                                                        inline
                                                        label={newsletters.newsletter}
                                                        type="checkbox"
                                                        checked={userData?.newsletter}
                                                        onChange={(e) => setUserData(prevState => ({
                                                            ...prevState,
                                                            newsletter: e.target.checked
                                                        }))}
                                                        disabled={disabled || clientNumberModified}
                                                    />
                                                    <Form.Check
                                                        id={newsletters.newsletter_1}
                                                        inline
                                                        label={newsletters.newsletter_1}
                                                        type="checkbox"
                                                        checked={userData?.newsletter_1}
                                                        onChange={(e) => setUserData(prevState => ({
                                                            ...prevState,
                                                            newsletter_1: e.target.checked
                                                        }))}
                                                        disabled={disabled || clientNumberModified}
                                                    />
                                                    <Form.Check
                                                        id={newsletters.newsletter_2}
                                                        inline
                                                        label={newsletters.newsletter_2}
                                                        type="checkbox"
                                                        checked={userData?.newsletter_2}
                                                        onChange={(e) => setUserData(prevState => ({
                                                            ...prevState,
                                                            newsletter_2: e.target.checked
                                                        }))}
                                                        disabled={disabled || clientNumberModified}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={2}>
                                            <Form.Group className="mb-3" controlId="salutation">
                                                <Form.Label>Appellativo*</Form.Label>
                                                <Form.Select
                                                    disabled={disabled || clientNumberModified}
                                                    value={userData?.salutation}
                                                    onChange={(e) => setUserData({
                                                        ...userData,
                                                        salutation: e.target.value
                                                    })}
                                                >
                                                    <option value="" disabled>Selezionare appellativo</option>
                                                    <option value="SIGNOR">Signor</option>
                                                    <option value="SIGNORA">Signora</option>
                                                    <option value="AZIENDA">Azienda</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={4}>
                                            <Form.Group className="mb-3" controlId="firstName">
                                                <Form.Label>Nome*</Form.Label>
                                                <Form.Control type="text" disabled={disabled || clientNumberModified}
                                                              value={userData.firstName}
                                                              onChange={(e) => setUserData({
                                                                  ...userData,
                                                                  firstName: e.target.value
                                                              })}
                                                              autocomplete="off"/>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={4}>
                                            <Form.Group className="mb-3" controlId="lastName">
                                                <Form.Label>Cognome*</Form.Label>
                                                <Form.Control type="text" disabled={disabled || clientNumberModified}
                                                              value={userData.lastName}
                                                              onChange={(e) => setUserData({
                                                                  ...userData,
                                                                  lastName: e.target.value
                                                              })}
                                                              autocomplete="off"/>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={2}>
                                            <Form.Group className="mb-3" controlId="dob">
                                                <Form.Label>Data di nascita</Form.Label>
                                                <Form.Control type="date" value={userData.dob} disabled={disabled || clientNumberModified}
                                                              onChange={(e) => setUserData({
                                                                  ...userData,
                                                                  dob: e.target.value
                                                              })}
                                                              autocomplete="off"/>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={5}>
                                            <Form.Group className="mb-3" controlId="street">
                                                <Form.Label>Via</Form.Label>
                                                <Form.Control type="text"
                                                              value={userData.addressProfile?.[0]?.street}
                                                              disabled={disabled || clientNumberModified}
                                                              onChange={(e) => setUserData({
                                                                  ...userData,
                                                                  addressProfile: [{
                                                                      ...userData.addressProfile?.[0],
                                                                      street: e.target.value
                                                                  }],
                                                              })}
                                                              autocomplete="off"/>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={1}>
                                            <Form.Group className="mb-3" controlId="streetNumber">
                                                <Form.Label>Nr. Civico</Form.Label>
                                                <Form.Control type="text"
                                                              value={userData.addressProfile?.[0]?.streetNumber}
                                                              disabled={disabled || clientNumberModified}
                                                              onChange={(e) => setUserData({
                                                                  ...userData,
                                                                  addressProfile: [{
                                                                      ...userData.addressProfile?.[0],
                                                                      streetNumber: e.target.value
                                                                  }],
                                                              })}
                                                              autocomplete="off"/>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={1}>
                                            <Form.Group className="mb-3" controlId="zip">
                                                <Form.Label>CAP</Form.Label>
                                                <Form.Control type="text"
                                                              value={userData.addressProfile?.[0]?.zip}
                                                              disabled={disabled || clientNumberModified}
                                                              onChange={(e) => setUserData({
                                                                  ...userData,
                                                                  addressProfile: [{
                                                                      ...userData.addressProfile?.[0],
                                                                      zip: e.target.value
                                                                  }],
                                                              })}
                                                              autocomplete="off"/>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={3}>
                                            <Form.Group className="mb-3" controlId="city">
                                                <Form.Label>Località</Form.Label>
                                                <Form.Control type="text"
                                                              value={userData.addressProfile?.[0]?.city}
                                                              disabled={disabled || clientNumberModified}
                                                              onChange={(e) => setUserData({
                                                                  ...userData,
                                                                  addressProfile: [{
                                                                      ...userData.addressProfile?.[0],
                                                                      city: e.target.value
                                                                  }],
                                                              })}
                                                              autocomplete="off"/>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={2}>
                                            <Form.Group className="mb-3" controlId="country">
                                                <Form.Label>Paese</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    value={userData.addressProfile?.[0]?.country || 'CH'}
                                                    disabled={disabled || clientNumberModified}
                                                    onChange={(e) =>
                                                        setUserData({
                                                            ...userData,
                                                            addressProfile: [
                                                                {
                                                                    ...userData.addressProfile?.[0],
                                                                    country: e.target.value,
                                                                },
                                                            ],
                                                        })
                                                    }
                                                >

                                                    <option value='IT'>Italy</option>
                                                    <option value='FR'>France</option>
                                                    <option value='DE'>Germany</option>
                                                    <option value='UK'>United Kingdom</option>
                                                    <option value='ES'>Spain</option>

                                                    {Object.keys(countries).map((code) => {
                                                        if (['IT', 'FR', 'DE', 'UK', 'ES', 'AI', 'AQ', 'AX', 'BL', 'BM', 'BQ', 'BV', 'CC', 'CD', 'CI', 'CK', 'CW', 'CX', 'EH', 'FK', 'FM', 'GF', 'GG', 'GI', 'GL', 'GP', 'GQ', 'GS', 'GU', 'HM', 'IM', 'IO', 'JE', 'KN', 'KY', 'ME', 'MF', 'MH', 'MO', 'MP', 'MQ', 'MS', 'NC', 'NF', 'NU', 'PF', 'PM', 'PN', 'PS', 'PW', 'RE', 'RS', 'SH', 'SJ', 'SS', 'ST', 'SX', 'TC', 'TF', 'TK', 'TL', 'UM', 'VG', 'WF', 'WS', 'XK', 'YT'].includes(code)) {
                                                            return null; // Non inserire queste opzioni
                                                        }
                                                        return (
                                                            <option key={code} value={code}>
                                                                {countries[code].name}
                                                            </option>
                                                        );
                                                    })}


                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={4}>
                                            <Form.Group className="mb-3" controlId="email">
                                                <Form.Label>Email*</Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    value={userData.email}
                                                    onChange={handleChange}
                                                    autoComplete="off"
                                                    disabled={(param.id && currentUser?.role !== 'superAdmin') || disabled || clientNumberModified}
                                                    isInvalid={emailError !== ''}
                                                />
                                                <Form.Control.Feedback
                                                    type="invalid">{emailError}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={3}>
                                            <Form.Group className="mb-3" controlId="mobilePhone">
                                                <Form.Label>Cellulare</Form.Label>
                                                <PhoneInput
                                                    international
                                                    disabled={disabled || clientNumberModified}
                                                    defaultCountry={"CH"}
                                                    countryCallingCodeEditable={true}
                                                    value={userData.addressProfile?.[0]?.mobilePhone}
                                                    onChange={(e) => setUserData({
                                                        ...userData,
                                                        addressProfile: [{
                                                            ...userData.addressProfile?.[0],
                                                            mobilePhone: e ? e : ''
                                                        }],
                                                    })}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col lg={3}>
                                            <Form.Group className="mb-3" controlId="phone">
                                                <Form.Label>Telefono</Form.Label>
                                                <PhoneInput
                                                    international
                                                    defaultCountry={"CH"}
                                                    disabled={disabled || clientNumberModified}
                                                    countryCallingCodeEditable={true}
                                                    value={userData.addressProfile?.[0]?.phone}
                                                    onChange={(e) => setUserData({
                                                        ...userData,
                                                        addressProfile: [{
                                                            ...userData.addressProfile?.[0],
                                                            phone: e ? e : ''
                                                        }],
                                                    })}
                                                />
                                            </Form.Group>
                                        </Col>
                                        {currentUser?.role === 'superAdmin' ? 
                                        <Col lg={2}>
                                            <Form.Group className="mb-3 disabled-copy" controlId="clientNumber">
                                                <Form.Label>Numero cliente edit</Form.Label>
                                                <div className="d-flex">
                                                    <Form.Control type="text" disabled={disabled}
                                                      value={userData.clientNumber}
                                                      onChange={(e) => {
                                                          const newValue = e.target.value;
                                                          setUserData({
                                                              ...userData,
                                                              clientNumber: newValue
                                                          });
                                                          setClientNumberModified(newValue !== originalClientNumber);
                                                      }}
                                                      autocomplete="off"/>
                                                    {clientNumberModified && (
                                                        <Button 
                                                            variant="outline-secondary" 
                                                            size="sm" 
                                                            className="ms-1"
                                                            onClick={cancelClientNumberChanges}
                                                            title="Annulla modifiche"
                                                        >
                                                            ✕
                                                        </Button>
                                                    )}
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        :
                                        <Col lg={2}>
                                            <Form.Group className="mb-3 disabled-copy" controlId="clientNumber">
                                                <Form.Label>Numero cliente</Form.Label>
                                                <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
                                                    <Form.Control type="text"
                                                                  value={userData.clientNumber}
                                                                  autocomplete="off"
                                                                  className={'disabled-copy-input'}
                                                                  style={{pointerEvents: 'auto'}}
                                                                  readOnly
                                                                  ref={clientNumberInputRef}
                                                                  onClick={() => handleCopyToClipboard()}/>
                                                </OverlayTrigger>
                                                <FontAwesomeIcon icon={faCopy}/>
                                            </Form.Group>
                                        </Col>
                                        }
                                    </Row>
                                    <Row>
                                        {!param.id ?
                                            <>
                                                <Col lg={3}>
                                                    <Form.Group className="mb-3" controlId="password">
                                                        <Form.Label>Password</Form.Label>
                                                        <Form.Control type="password" value={userData.password}
                                                                      onChange={(e) => setUserData({
                                                                          ...userData,
                                                                          password: e.target.value
                                                                      })}
                                                                      autocomplete="off"
                                                                      disabled={param.id || disabled}/>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={3}>
                                                    <Form.Group className="mb-3" controlId="confirmPassword">
                                                        <Form.Label>Ripeti Password</Form.Label>
                                                        <Form.Control type="password" value={confirmPassword}
                                                                      onChange={(e) =>
                                                                          checkPasswordValidation(e.target.value)
                                                                      }
                                                                      autocomplete="off"
                                                                      disabled={param.id || disabled}/>
                                                        {passwordMatchError && (
                                                            <Form.Text className="text-danger">
                                                                Le password non corrispondono.
                                                            </Form.Text>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                            </>
                                            :
                                            <></>
                                        }
                                        <Col lg={6}>
                                            <Form.Group className="mb-3" controlId="notes">
                                                <Form.Label>Note</Form.Label>
                                                <Form.Control as="textarea" rows={1} value={userData.notes}
                                                              disabled={disabled || clientNumberModified}
                                                              onChange={(e) => setUserData({
                                                                  ...userData,
                                                                  notes: e.target.value
                                                              })} autocomplete="off"/>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {param.id && userData.status === statuses.enabled ?
                                        <Row className='mt-3'>
                                            <Col lg={12}>
                                                <Table striped bordered size="sm">
                                                    <thead>
                                                    <tr>
                                                        <th>Tipologia abbonamento</th>
                                                        <th>Data attivazione</th>
                                                        <th>Data scadenza</th>
                                                        <th>Stato</th>
                                                        <th className={'text-end'}></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {userData && userData.subscriptions && userData.subscriptions.length > 0 ? (
                                                        userData.subscriptions.map((sub) => (
                                                            <tr key={sub.userSubscriptionId}>
                                                                <td>{sub.description}</td>
                                                                <td>{sub.activationDate}</td>
                                                                <td>{sub.expirationDate}</td>
                                                                <td>{sub.status}</td>
                                                                <td className={'text-end'}>
                                                                    <Button
                                                                        onClick={() => openModalToEdit(sub.userSubscriptionId)}
                                                                        variant={'link'} className={'p-0'}>
                                                                        <FontAwesomeIcon
                                                                            icon={faEdit}>
                                                                        </FontAwesomeIcon>
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <></>
                                                    )}
                                                    </tbody>
                                                </Table>
                                                <Row className={'justify-content-end'}>
                                                    <Col lg={2}>
                                                        <Button
                                                            onClick={() => openModalToCreate()}
                                                            variant={'outline-primary'}
                                                            size={'sm'} className={'w-100'}>
                                                            <FontAwesomeIcon icon={faPlus}
                                                                             className={'me-1'}/> Nuovo
                                                            abbonamento
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        :
                                        <></>}
                                </>
                            </Form>
                            <Row className={'justify-content-between mt-4'}>
                                <Col>
                                    <Button variant={'link'} onClick={() => navigate('/fe')}
                                            className={'text-decoration-none'}>
                                        <FontAwesomeIcon icon={faArrowLeft} className={'me-2'}/>
                                        Indietro
                                    </Button>
                                </Col>

                                <Col lg={2}>
                                    {param.id && userData?.status === statuses.enabled ?
                                        <Button variant={'outline-primary'} className={'w-100'}
                                                onClick={() => generateLinkChangePassword()}>Link cambio password</Button>
                                        :
                                        <></>}
                                </Col>

                                <Col lg={2}>
                                    {param.id && userData?.status !== statuses.disabled ?
                                        <Button variant={'outline-primary'} className={'w-100'}
                                                onClick={() => setShowModalConfirm(true)}>Cancella e anonimizza</Button>
                                        :
                                        <></>}
                                </Col>

                                <Col lg={2}>
                                    <Button variant={'primary'} className={'w-100'}
                                            disabled={checkForm()}
                                            onClick={() => param.id ? updateUser() : createUser()}>{param.id ? 'Aggiorna' : 'Crea'}</Button>
                                </Col>
                            </Row>
                        </Tab>
                        <Tab eventKey="history" title="History" disabled={!param.id}>
                            <Row className='mt-3'>
                                <Col>
                                    <DataTable
                                        columns={columns}
                                        data={subsHistory}
                                        highlightOnHover
                                        pagination
                                        paginationComponentOptions={paginationOptions}
                                    />
                                </Col>
                            </Row>
                            <Row className={'mt-3 mb-4'}>
                                <Col>
                                    <Button variant={'link'} onClick={() => navigate('/fe')}
                                            className={'text-decoration-none'}>
                                        <FontAwesomeIcon icon={faArrowLeft} className={'me-2'}/>
                                        Indietro
                                    </Button>
                                </Col>
                            </Row>
                        </Tab>
                    </Tabs>
                </Col>
            </Row>

            <Modal show={showModalSub} onHide={handleClose} size="lg" centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{isEdit ? 'Modifica Abbonamento' : 'Crea Abbonamento'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col lg={4}>
                            <Form.Group className="mb-3" controlId="description">
                                <Form.Label>Tipologia abbonamento</Form.Label>
                                <Form.Control as="select"
                                              value={isEdit ? subscriptionId : undefined}
                                              onChange={(e) => setSubscriptionId(e.target.value)}>
                                    {allSubType.length > 0 ? (allSubType.map(subType => {

                                            return <option
                                                key={subType.id} value={subType.id}>{subType.description}</option>
                                        }))
                                        :
                                        <></>
                                    })

                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col lg={4}>
                            <Form.Group className="mb-3" controlId="activationDate">
                                <Form.Label>Data attivazione</Form.Label>
                                <Form.Control type="date"
                                              value={activationDate}
                                              onChange={(e) => setActivationDate(e.target.value)}/>

                            </Form.Group>
                        </Col>
                        <Col lg={4}>
                            <Form.Group className="mb-3" controlId="expirationDate">
                                <Form.Label>Data scadenza</Form.Label>
                                <Form.Control type="date"
                                              value={expirationDate}
                                              onChange={(e) => setExpirationDate(e.target.value)}/>
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={handleClose}>
                        Annulla
                    </Button>
                    <Button variant="primary"
                            onClick={() => isEdit ? updateSubscription() : createSubscription()}>
                        Salva
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModalConfirm} onHide={() => setShowModalConfirm(false)} centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Conferma</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Sei sicuro di voler procedere? <b>L'azione è irreversibile</b></p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={() => setShowModalConfirm(false)}>
                        Annulla
                    </Button>
                    <Button variant="primary" onClick={() => safeDeleteUser(userData?.email)}>
                        Conferma
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={modalLinkChangePassword} onHide={() => setModalLinkChangePassword(false)} centered backdrop="static" size={'xl'}>
                <Modal.Header closeButton>
                    <Modal.Title>Link generato per cambio password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Col>
                        <Form.Group className="mb-3 disabled-copy" controlId="linkChangePassword">
                            <Form.Label>Link</Form.Label>
                            <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
                                <Form.Control type="text"
                                              value={linkChangePassword}
                                              autocomplete="off"
                                              className={'disabled-copy-input'}
                                              style={{pointerEvents: 'auto'}}
                                              readOnly
                                              ref={linkChangePasswordRef}
                                              onClick={() => handleCopyToClipboardLink()}/>
                            </OverlayTrigger>
                            <FontAwesomeIcon icon={faCopy}/>
                        </Form.Group>
                    </Col>
                </Modal.Body>
            </Modal>
        </>

    );
}

export default EditUser;